import React from "react";
import "./HomeOurClients.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function HomeOurClients({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    subtitle: "OUR CLIENT",
    heading: "PARTNERING WITH INDUSTRY LEADERS",
    description:
      "We work with a diverse portfolio of clients—from multinational corporations and financial institutions to government bodies and family-owned enterprises.",
    clients: [
      "TOTAL ENERGY",
      "ETHIOPIAN AIRLINE",
      "TOTAL ENERGY",
      "BLUEBERRY TRAVELS",
      "NEXT HOLIDAYS",
      "FRIENDS TRAVEL",
      "KAISER VOYAGE",
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    subtitle: "NOS CLIENTS",
    heading: "PARTENARIAT AVEC DES LEADERS DU SECTEUR",
    description:
      "Nous collaborons avec un portefeuille diversifié de clients, allant des multinationales et institutions financières aux organismes publics et entreprises familiales.",
 clients: [
  "TOTAL ÉNERGIES",
  "ETHIOPIAN AIRLINES",
  "TOTAL ÉNERGIES",
  "BLUEBERRY TRAVELS",
  "NEXT HOLIDAYS",
  "FRIENDS TRAVEL",
  "KAISER VOYAGE",
]

  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { subtitle, heading, description, clients } = data;

  return (
    <section className="home-ourclients-section section">
      <div className="text-center">
        {/* Section Top Part */}
        <div className="d-flex align-items-center justify-content-center mb-2">
          <div className="about-line me-3"></div>
          <p className="service-subtitle mb-0">{subtitle}</p>
        </div>

        <h2 className="client-heading">{heading}</h2>
        <p className="client-subtext">{description}</p>

        {/* Client Cards */}
        <div className="clients-row mt-4">
          {clients.map((item, index) => (
            <div key={index}>
              <div className="client-card">{item}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
